export const FILTERS = [
  { label: 'Highest rated', value: 'reviews' },
  { label: 'Ease of use', value: 'ease_of_use' },
  { label: 'Value for money', value: 'value_for_money' },
]

export const CATEGORIES = [
  { label: 'CRM Software', url: '/customer-management-software/crm/', slug: 'crm' },
  {
    label: 'Project Management Software',
    url: '/project-management-planning-software/project-management/',
    slug: 'project-management',
  },
  { label: 'Accounting Software', url: '/finance-accounting-software/accounting/', slug: 'accounting' },
  { label: 'Scheduling Software', url: '/operations-management-software/scheduling/', slug: 'scheduling' },
  {
    label: 'Inventory Management Software',
    url: '/operations-management-software/inventory-management/',
    slug: 'inventory-management',
  },
  { label: 'Payroll Software', url: '/hr-employee-management-software/payroll/', slug: 'payroll' },
  { label: 'Email Marketing Software', url: '/marketing-software/email-marketing/', slug: 'email-marketing' },
  { label: 'Call Center Software', url: '/customer-service-support-software/call-center/', slug: 'call-center' },
  {
    label: 'Construction Estimating Software',
    url: '/construction-software/construction-estimating/',
    slug: 'construction-estimating',
  },
  {
    label: 'Time Tracking Software',
    url: '/project-management-planning-software/time-tracking/',
    slug: 'time-tracking',
  },
  {
    label: 'Construction Management Software',
    url: '/construction-software/construction-management/',
    slug: 'construction-management',
  },
  {
    label: 'Contractor Management Software',
    url: '/operations-management-software/contractor-management/',
    slug: 'contractor-management',
  },
  {
    label: 'Document Management Software',
    url: '/collaboration-software/document-management/',
    slug: 'document-management',
  },
  {
    label: 'Appointments Scheduling Software',
    url: '/customer-management-software/appointments-scheduling/',
    slug: 'appointments-scheduling',
  },
  { label: 'Digital Signage Software', url: '/marketing-software/digital-signage/', slug: 'digital-signage' },
]
